import { RuleBlock } from 'modules/journey/components/RuleBuilder/RuleBlock';
import { useRuleBuilder } from 'modules/journey/components/RuleBuilder/hooks/useRuleBuilder';

export const HoldRuleBuilder = () => {
  const { state } = useRuleBuilder();
  const { rules } = state;

  // CURRENTLY can only do one rule. if hasChildRule is true, then we can't add more rules, yet.
  const hasChildRule = rules.some((rule) => rule.childRules.length > 0);
  return (
    <div>
      {rules.map((rule, idx) => {
        return (
          <span key={rule?.id ? `r${rule.id}` : `i${idx}`}>
            <RuleBlock
              rule={rule}
              ruleIdx={idx}
              canDelete={rules.length > 1}
              canAddRules={!hasChildRule}
              isMaxOneRule
            />
          </span>
        );
      })}
    </div>
  );
};
